import React, {FC} from 'react';
import styled from 'styled-components';

import {HandlerOf} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {CircleEditorTeammateDropdown} from './circleEditorTeammateDropdown';
import {CircleEditorTeammateTable} from './circleEditorTeammateTable';

/*
 * Props.
 */

interface CircleEditorTeammatesPickerProps {
  teammateIds: ReadonlyArray<number>;
  onChange: HandlerOf<ReadonlyArray<number>>;
  circleId?: number;
}

/*
 * Styles.
 */

const StyledWrapperDiv = styled.div`
  flex: 1;
  width: 100%;
  flex-grow: 1;
  min-height: min-content;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const StyledCircleEditorTeammateDropdown = styled(CircleEditorTeammateDropdown)`
  margin-top: 8px;
  margin-bottom: 10px;
`;

/*
 * Component.
 */

export const CircleEditorTeammatesPicker: FC<CircleEditorTeammatesPickerProps> = (props) => {
  const {teammateIds, circleId, onChange} = props;

  return (
    <StyledWrapperDiv>
      <StyledCircleEditorTeammateDropdown teammateIds={teammateIds} onChange={onChange} />
      <CircleEditorTeammateTable teammateIds={teammateIds} circleId={circleId} onSetTeammateIds={onChange} />
    </StyledWrapperDiv>
  );
};
